import React from "react";
import { useTranslation } from "react-i18next";
import SEO from "components/SEO";
import EPCSolutionHeaderAnalyse from "./EPCSolutionHeaderAnalyse";
import EPCSolutionSectionFive from "./EPCSolutionSectionFive";
import EPCSolutionSectionFour from "./EPCSolutionSectionFour";
import EPCSolutionSectionThree from "./EPCSolutionSectionThree";
import EPCSolutionSectionTwo from "./EPCSolutionSectionTwo";

const SolutionPage = () => {
  const { t } = useTranslation("solutionEpc");
  return (
    <>
      <SEO title={t("meta.title")} description={t("meta.description")} />
      <EPCSolutionHeaderAnalyse />
      <EPCSolutionSectionTwo />
      <EPCSolutionSectionThree />
      <EPCSolutionSectionFour />
      <EPCSolutionSectionFive />
    </>
  );
};

export default SolutionPage;
